<template>
	<AuthLayout redirectTo="/flow">
		<FlowEditor/>
	</AuthLayout>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import AuthLayout from '../../layouts/Auth/index.vue';
	import FlowEditor from '../../components/FlowEditor/index.vue';

	@Component({
		components: {
			AuthLayout,
			FlowEditor,
		},
	})
	export default class ViewFlow extends Vue {
	}
</script>

<style lang="scss">

</style>